export default {
  setSections: (state, sections) => {
    state.sections = sections
  },
  setTerm: (state, term) => {
    state.term = term
  },
  setTermLabel: (state, label) => {
    state.termLabel = label
  },
  setSectionCount: (state, count) => {
    state.sectionCount = count
  },
  setSlideCount: (state, count) => {
    state.slideCount = count
  },
  setFilter: (state, filters) => {
    state.filters = filters
  },
  updateFilter: (state, filters) => {
    for (let l in filters) {
      state.filters[l] = filters[l]
    }
  },
  setPagination: (state, pagination) => {
    state.pagination = pagination
  },
  setStudents: (state, students) => {
    state.students = students
  },
  updateStudent: (state, { index, data }) => {
    state.students.splice(index, 1, data)
  },
  setStudentCount: (state, count) => {
    state.studentCount = count
  },
  setAdvisingSelection: (state, id) => {
    state.advisingSelection = id
  }
}
